<!-- ======= Footer ======= -->
<footer id="footer" class="footer">
  <div class="copyright">
    &copy; Copyright <strong><span>Haylli Restaurant</span></strong
    >. All Rights Reserved
  </div>
</footer>
<!-- End Footer -->
